import { render, staticRenderFns } from "./switch-widget.vue?vue&type=template&id=671da7ab&scoped=true&"
import script from "./switch-widget.vue?vue&type=script&lang=js&"
export * from "./switch-widget.vue?vue&type=script&lang=js&"
import style0 from "./switch-widget.vue?vue&type=style&index=0&id=671da7ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671da7ab",
  null
  
)

export default component.exports